import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ConfirmedFilled } from '../private/icons/ConfirmedFilled';
import { RadioButtonUnchecked } from '../private/icons/RadioButtonUnchecked';
import useTile from '../private/components/tile/useTile';
import useTileContent from '../private/components/tile/useTileContent';

const TileStateIndicator = React.forwardRef((props, ref) => {
  const { position = 'middle' } = props;

  const { selected } = useTile();
  const { orientation } = useTileContent();

  const iconClasses = classNames('sui-w-4 sui-h-4 sui-rounded-full',
    'group-hover:sui-outline group-hover:sui-outline-2 group-hover:sui-outline-brand-subtle',
    'group-active:sui-outline group-active:sui-outline-2 group-active:sui-outline-brand-subtle group-active:sui-outline-4', {
      'sui-fill-primary group-hover:sui-fill-brand group-active:sui-fill-primary': selected,
      'sui-fill-medium group-hover:sui-fill-brand group-active:sui-fill-brand': !selected,
    });

  const layoutClasses = classNames('sui-h-full sui-flex sui-justify-center', {
    'sui-items-start': position === 'top',
    'sui-items-center': position === 'middle',
    'sui-items-end': position === 'bottom'
  });

  const icon = selected
    ? (
      <ConfirmedFilled color="inherit" size="small" />
    )
    : (
      <RadioButtonUnchecked color="inherit" size="small" />
    );

  if (orientation === 'vertical') return null;

  return (
    <div className={layoutClasses} ref={ref}>
      <span className={iconClasses}>
        { icon }
      </span>
    </div>
  );
});

TileStateIndicator.propTypes = {
  position: PropTypes.oneOf(['top', 'middle', 'bottom'])
};

export { TileStateIndicator };
